// extracted by mini-css-extract-plugin
module.exports = {"value":"styles-module--value--1H0AI","title":"styles-module--title--2jfZu","divider":"styles-module--divider--2lPJo"};